// 头像的背景色根据老师id取余20
let bgList = [
    '#a7e5cb',
    '#b4e291',
    '#62d6c6',
    '#62ca98',
    '#37d6bc',
    '#4bc4c8',
    '#afe17d',
    '#c2d93d',
    '#e4d44b',
    '#ffd47d',
    '#7db1ff',
    '#81a2ff',
    '#7d97ff',
    '#969ae2',
    '#ad94f9',
    '#d296ea',
    '#fa97ed',
    '#f0a4c6',
    '#ffbc93',
    '#ffa6a6'
  ]
function avatarBgColor(id){
    return bgList[id % 20]
}
  
export default avatarBgColor;